export default "__VITE_ASSET__B8QXB_6O__"